/**
 * Application constants
 */

export const LD_CONTEXT_COOKIE_KEY = "ld-context"

